import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { PortfolioStatus } from "@/components/portfolio/PortfolioStatus";
import { PortfolioPrism } from "@/components/portfolio/PortfolioPrism";
import { ArtworkImage } from "@/components/ArtworkImage";
import { ARTWORK_SIZES } from "@/config/artwork";
import { lockedMessage, useUnlock } from "@/context/TokenDataContext";

export const ThematicPortfolioCard = ({ portfolio, index, celebrating = false, reducedMotion = false }) => {
  const { isUnlocked } = useUnlock();

  const handleClick = () => {
    if (!isUnlocked) {
      toast(lockedMessage("portfolio"), { icon: <Lock className="h-4 w-4 text-gold" /> });
      return;
    }
    toast.success(`${portfolio.name} PORTFOLIO is unlocked and available.`);
  };

  return (
    <motion.button
      type="button"
      onClick={handleClick}
      aria-disabled={!isUnlocked}
      className={`pf-card ${isUnlocked ? "pf-card--unlocked" : "pf-card--locked"}`}
      style={{ "--card-accent": portfolio.color, "--portfolio-index": index }}
      initial={{ opacity: 0, y: reducedMotion ? 0 : 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.8, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      whileHover={reducedMotion ? undefined : { y: -6 }}
      data-testid={`portfolio-card-${portfolio.id}`}
      data-state={isUnlocked ? "unlocked" : "locked"}
      data-lucky-reveal={celebrating}
    >
      <PortfolioPrism id={portfolio.id} />
      <div
        className={`pf-card__media${portfolio.image.unobscured ? " pf-card__media--unobscured" : ""}`}
        data-testid={`portfolio-card-${portfolio.id}-media`}
      >
        <ArtworkImage artwork={portfolio.image} sizes={ARTWORK_SIZES.portfolio} testId={`portfolio-card-${portfolio.id}-image`} />
      </div>
      <div className="flex flex-1 flex-col gap-3 px-3.5 pb-3.5 pt-0">
        <div className="text-center leading-tight">
          <div className={`pf-card__name ${portfolio.name.length > 10 ? "!text-[0.68rem]" : ""}`} data-testid={`portfolio-card-${portfolio.id}-name`}>{portfolio.name}</div>
          <div className="mt-0.5 font-display text-[0.62rem] font-semibold tracking-[0.2em] text-white/80" data-testid={`portfolio-card-${portfolio.id}-type`}>PORTFOLIO</div>
        </div>
        <PortfolioStatus testId={`portfolio-card-${portfolio.id}-unlock-status`} celebrating={celebrating} />
      </div>
    </motion.button>
  );
};
